import React, { FC } from "react";
import isEmpty from "lodash/isEmpty";
import { FILTER_TYPES } from "../constants";
import FilterRangeMob from "./filterRangeMob";
import FilterMultiSelectMob from "./filterMultiSelectMob";
import FilterSizeMob from "./filterSizeMob";
import FilterCategoryMob from "./filterCategoryMob";
import MoreFiltersPlaceholder from "./moreFiltersPlaceholder";
import {
  CategoryFacet,
  Facet,
  FilterType,
  GeneralFacet,
  MultiSelectFacet,
  NewSizeFacet,
  PriceFacet,
  PriceFilterOption,
  SizeFacet
} from "../types";

type FilterProps = {
  filter: Omit<Facet, "sortOrder">;
  setToggledFilter: (
    filter: FilterType | PriceFilterOption | EmptyObject
  ) => void;
  toggledFilter: Facet;
  onApplyButtonClick: (...args) => void;
  onSelectCategory?: () => void;
  selectedCategoryCount?: number;
};

const s = {
  data: [],
  defaultLabel: "Brand",
  label: "Brand",
  queryParam: "brand",
  search: { enabled: true, placeholder: "Search Brands" },
  type: "multiSelect",
  viewType: ""
};

const FilterContainer: FC<FilterProps> = ({
  setToggledFilter,
  toggledFilter,
  onApplyButtonClick,
  onSelectCategory,
  selectedCategoryCount
}) => {
  if (isEmpty(toggledFilter)) throw new Error();

  if ((toggledFilter as any).type === FILTER_TYPES.MORE_FILTERS) {
    return (
      <MoreFiltersPlaceholder
        onSelectCategory={onSelectCategory ?? (() => {})}
        selectedCategoryCount={selectedCategoryCount}
      />
    );
  }

  switch (toggledFilter.type) {
    case FILTER_TYPES.MULTI_SELECT:
      return (
        <FilterMultiSelectMob
          filter={toggledFilter as GeneralFacet & MultiSelectFacet}
        />
      );
    case FILTER_TYPES.CATEGORY:
      return (
        <FilterCategoryMob
          filter={toggledFilter as GeneralFacet & CategoryFacet}
          setToggledFilter={setToggledFilter}
          toggledFilter={toggledFilter}
          onApplyButtonClick={onApplyButtonClick}
        />
      );
    case FILTER_TYPES.PRICE:
      return (
        <FilterRangeMob
          filter={toggledFilter as GeneralFacet & PriceFacet}
          setToggledFilter={setToggledFilter}
          toggledFilter={toggledFilter as any}
        />
      );
    case FILTER_TYPES.SIZE:
      return (
        <FilterSizeMob
          filter={toggledFilter as GeneralFacet & NewSizeFacet}
          setToggledFilter={setToggledFilter}
          toggledFilter={toggledFilter as any}
        />
      );
    default:
      return null;
  }
};

export default FilterContainer;
